import { useEffect } from "react";
import { useUser } from "../context/UserContext";
import { useOptionalTenant } from "../tenant/TenantContext";
import { loadImpersonationSession } from "../supportMode/supportModeSession";

/**
 * Direct-login canonical chrome hydration.
 *
 * Auth0 session → active Master Account bootstrap ready → GET /me/profile →
 * shared UserContext. Runs once per authenticated sub (UserContext dedupes);
 * stays mounted across route changes inside the authenticated layout route,
 * and re-runs on a full page refresh.
 *
 * Support Mode: never runs — the shell owns the selected user's chrome.
 * Renders nothing.
 */
export default function CanonicalProfileHydrator() {
  const { hydrateCanonicalProfile } = useUser();
  const tenant = useOptionalTenant();
  const tenantReady = Boolean(tenant?.isReady);
  const activeMasterAccountId = tenant?.tenant?.masterAccountId || null;

  useEffect(() => {
    if (!tenantReady) return;
    if (loadImpersonationSession()) return;
    if (typeof hydrateCanonicalProfile !== "function") return;
    hydrateCanonicalProfile();
  }, [tenantReady, activeMasterAccountId, hydrateCanonicalProfile]);

  return null;
}
